import React, { useEffect, useRef, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
type CountdownUnitProps = {
  value: number;
  label: string;
};
export function OfferCountdown() {
  const targetTimeRef = useRef(getNextLocalMidnight());
  const [remainingSeconds, setRemainingSeconds] = useState(() => getRemainingSeconds(targetTimeRef.current));
  useEffect(() => {
    const updateCountdown = () => {
      const now = Date.now();
      if (targetTimeRef.current <= now) {
        targetTimeRef.current = getNextLocalMidnight(now);
      }
      setRemainingSeconds(getRemainingSeconds(targetTimeRef.current, now));
    };
    updateCountdown();
    const intervalId = window.setInterval(updateCountdown, 1000);
    return () => window.clearInterval(intervalId);
  }, []);
  const hours = Math.floor(remainingSeconds / 3600);
  const minutes = Math.floor(remainingSeconds % 3600 / 60);
  const seconds = remainingSeconds % 60;
  return <section aria-labelledby="offer-countdown-title" className="mt-10 border border-[#e34b4b]/70 bg-ink px-5 py-8 text-center shadow-[0_16px_40px_rgba(0,0,0,0.22)] sm:px-8 sm:py-10" data-id="element-101" data-mp="31li0z8q8m9j0">
      <div className="mx-auto max-w-3xl" data-id="element-102" data-mp="21r9npt7rdl47">
        <div className="flex items-center justify-center gap-2 text-[#e34b4b]" data-id="element-103" data-mp="1wrdf1go495ib">
          <Clock3Icon size={16} strokeWidth={2} aria-hidden="true" data-id="element-104" data-mp="1wtghj06ggr3x" />
          <p className="text-xs font-bold uppercase tracking-[0.2em]" data-id="element-105" data-mp="1rs0skx15q0g9">
            Oferta de lanzamiento por tiempo limitado
          </p>
        </div>

        <h2 id="offer-countdown-title" className="mt-4 font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-106" data-mp="1j0ibmjwdzgm4">
          El precio especial termina en:
        </h2>

        <div className="mt-6 flex items-start justify-center gap-2 text-white sm:gap-4" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos para el cierre de la oferta.`} data-id="element-107" data-mp="1933you9o99yk">
          <CountdownUnit value={hours} label="Horas" data-id="element-108" data-mp="101wa53wyjnho" />
          <span className="pt-1 font-display text-4xl font-bold leading-none text-[#e34b4b] sm:pt-2 sm:text-6xl" aria-hidden="true" data-id="element-109" data-mp="pfraidenys14">
            :
          </span>
          <CountdownUnit value={minutes} label="Minutos" data-id="element-110" data-mp="ud9dzo9wwf1q" />
          <span className="pt-1 font-display text-4xl font-bold leading-none text-[#e34b4b] sm:pt-2 sm:text-6xl" aria-hidden="true" data-id="element-111" data-mp="ggmbl5z6wwof">
            :
          </span>
          <CountdownUnit value={seconds} label="Segundos" data-id="element-112" data-mp="194i9uf4eqwnb" />
        </div>

        <p className="mx-auto mt-7 max-w-xl text-sm font-medium leading-relaxed text-stone-200 sm:text-base" data-id="element-113" data-mp="196cs1loaoanp">
          Aprovechá hoy el acceso completo a los 6 módulos y los 4 bonos
          exclusivos con el precio especial vigente.
        </p>

        <div className="mx-auto mt-7 max-w-xl" data-id="element-114" data-mp="14cqiw3hcaown">
          <div className="h-2 border border-[#e34b4b]/60 bg-charcoal" data-id="element-115" data-mp="14bfeq2jzff50">
            <div role="progressbar" aria-label="Disponibilidad de la oferta" aria-valuemin={0} aria-valuemax={100} aria-valuenow={72} className="h-full w-[72%] bg-[#e34b4b]" data-id="element-116" data-mp="1s1jg039p72su" />
          </div>
          <div className="mt-2 flex items-center justify-between text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400 sm:text-xs" data-id="element-117" data-mp="2269lgj4b8p1t">
            <span data-id="element-118" data-mp="2g0aagl5gmxoz">Oferta vigente por hoy</span>
            <span className="text-[#e34b4b]" data-id="element-119" data-mp="2b0e6glwrj69f">72% reservado</span>
          </div>
        </div>
      </div>
    </section>;
}
function CountdownUnit({
  value,
  label
}: CountdownUnitProps) {
  const formattedValue = value.toString().padStart(2, '0');
  return <div className="min-w-[3.9rem] sm:min-w-[5.5rem]" data-id="element-120" data-mp="1x7yau666yaij">
      <span className="block font-display text-5xl font-bold leading-none tabular-nums sm:text-7xl" data-id="element-121" data-mp="1x8rdauy4aduv">
        {formattedValue}
      </span>
      <span className="mt-2 block text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400 sm:text-xs" data-id="element-122" data-mp="1sb7t7eeqn6v0">
        {label}
      </span>
    </div>;
}
function getNextLocalMidnight(now = Date.now()): number {
  const nextMidnight = new Date(now);
  nextMidnight.setHours(24, 0, 0, 0);
  return nextMidnight.getTime();
}
function getRemainingSeconds(targetTime: number, now = Date.now()): number {
  return Math.max(0, Math.ceil((targetTime - now) / 1000));
}